import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "form-container m-4 mt-0" }
const _hoisted_3 = { class: "my-10" }
const _hoisted_4 = { class: "font-bold" }

import { computed, ref } from 'vue';
import { useStore } from 'vuex';
import ModalSlots from "@/components/ModalSlots.vue";
import FormErrorToast from '@/components/FormErrorToast.vue';
import LoaderPage from "./LoaderPage.vue";
import { useMutation, useQuery } from "@vue/apollo-composable";
import {OTHER_TECHNOLOGY_PROPAGATE} from "@/grapql/benchlingMutations";
import { GET_BENCHLING_ENTITY_WEB_URL } from "@/grapql/benchlingQueries";
import { POSITION, useToast } from 'vue-toastification';
import BenchlingIcon from "@/components/icons/BenchlingIcon.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'AssetBenchlingLink',
  setup(__props) {

const toast = useToast();
const store = useStore();
const assetType = computed(() => store.getters["assetDetailModule/getAssetType"]);

const assetId = computed(() => store.getters["assetDetailModule/getAssetValues"].id);
const benchlingId  = computed(()=> store.getters["assetDetailModule/getAssetValues"].benchlingId);
const nickname = computed(() => store.getters["assetDetailModule/getAssetValues"].nickname);

const isOpen = ref(false);
const closeModal = () => { isOpen.value = false;}

const propagationError = ref(null);
const propagationInProgress = ref(false)
const openModal = () => {
    propagationError.value = null;
    propagationInProgress.value = false;
    isOpen.value = true; 
}

const handlePropagation = async () =>{
    propagationInProgress.value = true;
    propagationError.value = null;

    const { mutate: propagate, onDone, onError } = useMutation(OTHER_TECHNOLOGY_PROPAGATE);
    propagate({input: {"id": assetId.value}});
    onDone( async (result) => {
        if (result.data && result.data.otherTechnologyBenchlingPropagate.benchlingId) {
            store.commit('assetDetailModule/setOtherTechnologyBenchlingId', {benchlingId: result.data.otherTechnologyBenchlingPropagate.benchlingId});
            toast.success(`Asset Propagated Successfully`, { position: POSITION.BOTTOM_LEFT, timeout: 3000 });
            closeModal();
        }
        else{
            propagationError.value = "Failed to propagate asset to Benchling";
        }
        propagationInProgress.value = false;
        
    });
    onError( async (error) => {
        propagationInProgress.value = false;
        propagationError.value= error.message;
    })
}

// Open Benchling Detail Page
const isBEWULoading = ref(false);
const openBenchlingDetailPage = async () =>{
    isBEWULoading.value = true;

    const { onResult, onError } = useQuery(GET_BENCHLING_ENTITY_WEB_URL, {entityId:benchlingId}, {fetchPolicy: 'cache-and-network'});
    
    onResult(async queryResult => {

        if (queryResult.data && queryResult?.data.getBenchlingEntityWebUrl) {
            const benchlingUrl = queryResult.data.getBenchlingEntityWebUrl;
            console.log("Benchling URL: ", benchlingUrl);
            window.open(benchlingUrl, '_blank');
            isBEWULoading.value = false;
        }
    })
    onError(async error => {
        toast.error(error.message, { position: POSITION.BOTTOM_LEFT, timeout: 3000 });
        isBEWULoading.value = false;
    })

}

return (_ctx: any,_cache: any) => {
  return (assetType.value == 'otherTechnology')
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (benchlingId.value)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass(["round-action-icon", {'bg-gray-300':isBEWULoading.value, 'bg-green-600': !isBEWULoading.value}]),
              onClick: _cache[0] || (_cache[0] = ($event: any) => (!isBEWULoading.value && openBenchlingDetailPage())),
              title: "open benchling detail page"
            }, [
              _createVNode(BenchlingIcon)
            ], 2))
          : (_openBlock(), _createElementBlock("div", {
              key: 1,
              class: "round-action-icon",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (openModal())),
              title: "Propagate Asset to Benchling"
            }, [
              _createVNode(BenchlingIcon)
            ])),
        (!benchlingId.value)
          ? (_openBlock(), _createBlock(ModalSlots, {
              key: 2,
              show: isOpen.value,
              dialogClass: "propagate-asset-modal",
              onCloseModal: closeModal
            }, {
              header: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                _createElementVNode("p", null, "Propagate Asset to Benchling", -1)
              ]))]),
              body: _withCtx(() => [
                (propagationInProgress.value)
                  ? (_openBlock(), _createBlock(LoaderPage, {
                      key: 0,
                      "loader-text": "Propagating Asset to Benchling",
                      "gif-position": "center"
                    }))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_2, [
                  _createVNode(FormErrorToast, {
                    "is-showing": !!propagationError.value,
                    title: "FAILED!",
                    subtitle: propagationError.value,
                    "toast-type": "error"
                  }, null, 8, ["is-showing", "subtitle"]),
                  _createElementVNode("p", _hoisted_3, [
                    _cache[3] || (_cache[3] = _createTextVNode("By continuing, a ", -1)),
                    _createElementVNode("span", _hoisted_4, _toDisplayString(nickname.value), 1),
                    _cache[4] || (_cache[4] = _createTextVNode(" entry will be automatically created in Benchling. ", -1))
                  ])
                ])
              ]),
              footer: _withCtx(() => [
                _createElementVNode("button", {
                  class: "button cancel",
                  onClick: closeModal
                }, "cancel"),
                _createElementVNode("button", {
                  class: "button green-accept",
                  onClick: handlePropagation
                }, "Continue")
              ]),
              _: 1
            }, 8, ["show"]))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}
}

})